<template>
    <div class="c-picked__item u-flex-set">
        <span>{{item.Name}}</span>
        <div class="u-flex--push-left">
            <button class="c-button--reset c-button--icon-only u-inline-flex-set" type="button" @click="removeItem()" title="remove">
                <svgicon name="close"></svgicon>
            </button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: ['item'],
        methods: {
            removeItem() {
                this.$emit('remove', this.item)
            },
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";


</style>


// WEBPACK FOOTER //
// src/components/form/addressSelect/SelectedAddress.vue